import { useEffect, useState } from "react";
import botProfilService from "../services/botProfilService";
import storage from "/src/utils/storage";
import normalizeBotProfile from "../utils/normalizeBotProfile";

function useBotProfiles() {
    const [bots, setBots] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getBotProfiles } = botProfilService
    useEffect(() => {
        const fetchBotProfiles = async () => {
            const company = storage("session").get("company");
            if (!company) {
                setLoading(false);
                return;
            }

            const [result, error] = await getBotProfiles(company.id)
            if (!error && result) {
                setBots(result.map(normalizeBotProfile));
            }
            setLoading(false);
        };

        fetchBotProfiles();
    }, []);

    return { bots, loading };
}

export default useBotProfiles;
